var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"create-model"},[_c('p-edit-model',{attrs:{"is-request-pending":_vm.updatePending},on:{"submit":_vm.create}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }